import { useMutation } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type PublishWorkoutToGarminVariables = {
  workoutId: number;
};

export const usePublishWorkoutToGarmin = () => {
  const { data: accessToken } = useAccessToken();

  return useMutation({
    mutationFn: async ({ workoutId }: PublishWorkoutToGarminVariables) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/plan/workouts/${workoutId}/publish/garmin`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to publish workout to Garmin');
      }

      return response.json();
    },
  });
};
